import { render, staticRenderFns } from "./problemRecord.vue?vue&type=template&id=61bfa8d8&scoped=true"
import script from "./problemRecord.vue?vue&type=script&lang=js"
export * from "./problemRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bfa8d8",
  null
  
)

export default component.exports